module.exports = __webpack_public_path__ + "img/figure6.061568e7.png";